import { render, staticRenderFns } from "./DrawerDefinitionsTab.vue?vue&type=template&id=34053947&scoped=true"
import script from "./DrawerDefinitionsTab.vue?vue&type=script&lang=js"
export * from "./DrawerDefinitionsTab.vue?vue&type=script&lang=js"
import style0 from "./DrawerDefinitionsTab.vue?vue&type=style&index=0&id=34053947&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34053947",
  null
  
)

export default component.exports